import { fromJS } from 'immutable'

import { USER_POST, USER_UPDATE, USER_ERROR } from 'actions/create-user'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  error: false,
  errorData: null,
  loading: false,
  returnData: null,
})

export default function createUserReducer(state = initialState, action) {
  switch (action.type) {
    case USER_POST:
      return _postUser(state)
    case USER_UPDATE:
      return _updateUser(state, action.payload)
    case USER_ERROR:
      return _errorUser(state, action.payload)
    default:
      return state
  }
}

const _postUser = state => {
  return state.update('loading', () => true)
}

const _updateUser = (state, payload) => {
  return state
    .set('returnData', fromJS(payload.data))
    .update('loading', () => false)
    .update('error', () => false)
    .update('errorData', () => null)
}

const _errorUser = (state, payload) => {
  return state
    .set('error', payload.error)
    .set('errorData', fromJS(payload.data))
    .update('loading', () => false)
}
